import { gql } from "@apollo/client";

export const GET_TIME_ENTRY_BY_ID = gql`
	query ($id: UUID!) {
		GetTimeEntryByID(id: $id) {
			timeEntry {
				timeEntryGuid
				startTime
				endTime
				duration
				description
				employee {
					firstName
					lastName
					employeeGuid
					directManagerGuid
					tenantGuid
				}
				task {
					taskGuid
					title
					ticket {
						project {
							projectGuid
							title
							projectPermissions {
								resourceGuid
								canManageTimeEntries
							}
						}
					}
				}
				open
				synced
				automaticallyClosed
				billable
				timeSheet {
					timeSheetGuid
					status
				}
				timeEntryStatusGuid
				timeEntryStatus {
					description
					mnemonic
					timeEntryStatusGuid
					timeEntryStatusID
				}
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const UPDATE_TIME_ENTRY = gql`
	mutation ($model: UpdateTimeEntryNonSyncedBoolRequestInput!) {
		UpdateTimeEntryByManager(model: $model) {
			timeEntryCrud
			errorCode
			errorMessage
			errorVariables
			timeEntry {
				billable
			}
		}
	}
`;

export const CREATE_TIME_ENTRY = gql`
	mutation ($model: UpdateTimeEntryNonSyncedBoolRequestInput!) {
		CreateTimeEntryByManager(model: $model) {
			timeEntry {
				timeEntryGuid
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const CREATE_TIME_ENTRIES_FROM_EXCEL = gql`
	mutation ($model: ListUpdateTimeEntryNonSyncedBoolRequestInput!) {
		CreateTimeEntriesFromExcelByManager(model: $model) {
			timeEntryCrud
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const DELETE_TIME_ENTRY_LIST = gql`
	mutation ($model: DeleteTimeEntriesRequestModelInput!) {
		DeleteTimeEntries(model: $model) {
			timeEntryCrud
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const GET_TIME_ENTRIES = gql`
	query ($model: GetTimeEntriesRequestModelInput!) {
		GetTimeEntries(model: $model) {
			timeEntriesList {
				totalHours
				todaysTotal
				weeklyTotal
				timeEntries {
					timeEntryGuid
					isEditable
					timeSheetGuid
					modifiedBy {
						email
					}
					createdBy {
						email
					}
					creationDate
					modificationDate
					description
					employee {
						employeeGuid
						firstName
						lastName
						directManagerGuid
					}
					task {
						taskGuid
						title
						ticket {
							project {
								projectGuid
								title
								projectPermissions {
									resourceGuid
									canManageTimeEntries
								}
							}
						}
						parentTaskGuid
					}
					startTime
					endTime
					duration
					open
					synced
					automaticallyClosed
					billable
					timeEntryStatus {
						description
						mnemonic
						timeEntryStatusGuid
					}
					timeSheet {
						status
					}
					createdBy {
						email
					}
					creationDate
					modifiedBy {
						email
					}
					modificationDate
					rejectedBy {
						email
					}
					rejectionDate
					approvedBy {
						email
					}
					approvalDate
				}
				totalNumberOfRecords
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const GET_OPEN_TIME_ENTRIES = gql`
	query ($model: GetOpenTimeEntriesRequestModelInput!) {
		GetOpenTimeEntries(model: $model) {
			timeEntriesList {
				timeEntries {
					timeEntryGuid
					description
					isEditable
					employee {
						employeeGuid
						firstName
						lastName
						directManagerGuid
					}
					task {
						taskGuid
						title
						ticket {
							project {
								projectGuid
								title
							}
						}
					}
					startTime
					endTime
					duration
					open
					synced
					automaticallyClosed
					billable
					timeEntryStatus {
						description
						mnemonic
						timeEntryStatusGuid
					}
					timeSheet {
						status
					}
					createdBy {
						email
					}
					creationDate
					modifiedBy {
						email
					}
					modificationDate
				}
				totalNumberOfRecords
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const GET_TIME_ENTRIES_APPROVAL = gql`
	query ($model: GetTimeEntriesListRequestModelInput!) {
		GetTimeEntriesForApproval(model: $model) {
			timeSheetTimeEntries {
				totalDuration
				totalNumberOfRecords
				timeEntries {
					automaticallyClosed
					creationDate
					billable
					description
					duration
					employee
					modificationDate
					open
					project
					projectGuid
					startTime
					synced
					task
					taskGuid
					taskID
					timeEntryGuid
					timeSheetGuid
					createdBy {
						email
					}
					modifiedBy {
						email
					}
					timeEntryStatus {
						description
						mnemonic
						timeEntryStatusGuid
					}
					rejectedBy {
						email
					}
					rejectionDate
					approvedBy {
						email
					}
					approvalDate
				}
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

//check data and import to database if no error
export const CHECK_AND_CREATE_TIME_ENTRIES_FROM_EXCEL = gql`
	mutation ($model: CreateAndCheckTimeEntriesListRequestInput!) {
		CreateTimeEntriesFromBCExcelFormat(model: $model) {
			createTimeEntriesResult {
				createdTimeEntries
				result {
					billable
					date
					description
					error
					projectName
					resourceName
					taskName
					time
				}
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const MOVE_TIME_ENTRY = gql`
	mutation MoveTimeEntry($model: MoveTimeEntryRequestInput!) {
		MoveTimeEntry(model: $model) {
			timeEntryCrud
			errorCode
			errorMessage
		}
	}
`;

export const GET_ALL_TIME_ENTRIES_STATUS = gql`
	query ($model: GetAllTimeEntriesStatusRequestInput!) {
		GetTimeEntriesStatus(model: $model) {
			timeEntriesStatus {
				timeEntryStatusGuid
				mnemonic
				description
			}
			errorCode
			errorMessage
			errorVariables
		}
	}
`;

export const UPDATE_TIME_ENTRY_STATUS = gql`
	mutation ($model: UpdateTimeEntryStatusRequestModelInput!) {
		UpdateTimeEntryStatus(model: $model) {
			timeEntryCrud
			errorCode
			errorMessage
			errorVariables
		}
	}
`;
